"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Scale, Brain, Landmark, ShieldCheck, ArrowRight } from "lucide-react";
export default function ProfessionalProfile() {
  const imageReveal = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const contentReveal = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="167653" id="опыт-и-квалификация" className="bg-background text-foreground py-16 md:py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute bottom-[10%] -right-[10%] w-[40%] h-[40%] rounded-full bg-accent/10 blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-0 items-center">
          
          {}
          <div ref={imageReveal.ref} className={`lg:col-span-5 relative z-20 transition-all duration-1000 ease-out ${imageReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative aspect-[3/4] md:aspect-[4/5] lg:aspect-[3/4] w-full max-w-md mx-auto lg:max-w-none rounded-sm overflow-hidden shadow-2xl ring-1 ring-black/5">
              <img src="https://welcome-husky.10web.cloud/wp-content/uploads/2026/03/my-photo_2026-03-25_11_50_48.jpg" alt="Кондрашов Николай Евгеньевич - Адвокат" className="w-full h-full object-cover object-center" />
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-transparent to-transparent" />
              
              <div className="absolute bottom-6 left-6 right-6">
                <Badge variant="secondary" className="bg-white/90 backdrop-blur-md text-primary border-none mb-3 font-mono text-[10px] tracking-wider uppercase">
                  Реестровый номер 40/806
                </Badge>
                <h3 className="text-2xl font-serif font-medium text-white">Николай Кондрашов</h3>
                <p className="text-white/80 text-sm mt-1 font-sans">Адвокатская палата Калужской области</p>
              </div>
            </div>
          </div>

          {}
          <div ref={contentReveal.ref} className={`lg:col-span-7 lg:-ml-12 lg:pl-20 relative z-10 transition-all duration-1000 delay-200 ease-out ${contentReveal.isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="bg-white text-foreground rounded-sm p-8 md:p-12 lg:p-16 shadow-xl ring-1 ring-border">
              
              <div className="mb-10">
                <div className="flex items-baseline gap-2 mb-2">
                  <h2 className="font-mono text-6xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-slate-200">
                    11+
                  </h2>
                  <span className="text-2xl md:text-3xl font-serif font-medium text-secondary">ЛЕТ</span>
                </div>
                <p className="text-xs md:text-sm font-bold tracking-widest text-secondary uppercase">
                  Безупречной юридической практики
                </p>
              </div>

              <div className="space-y-6 text-secondary mb-10">
                <p className="text-lg leading-[1.8] font-sans">
                  Мой подход строится на пересечении двух дисциплин. Имея <strong>высшее юридическое и психологическое образования</strong>, я не просто анализирую сухие факты дела, но и понимаю скрытые мотивы оппонентов. Это дает неоспоримое стратегическое преимущество как за столом переговоров, так и в зале суда.
                </p>
                <p className="text-lg leading-[1.8] font-sans">
                  Специализируюсь на сложных гражданских делах (земля, жилье, семья) и комплексной защите бизнеса, включая арбитраж и взыскание проблемных долгов.
                </p>
              </div>

              <div className="space-y-4 mb-10">
                {}
                <div className="bg-accent/5 border border-accent/10 rounded-sm p-5 flex items-start gap-4 shadow-sm">
                  <div className="bg-primary text-primary-foreground p-2 rounded-sm shrink-0 mt-0.5">
                    <Landmark className="w-5 h-5" />
                  </div>
                  <div>
                    <h4 className="text-primary font-serif font-semibold mb-1">Опыт споров с корпорациями</h4>
                    <p className="text-secondary text-sm leading-relaxed">Успешный опыт ведения сложных споров против крупнейших банков и агрохолдингов. Защита интересов клиентов в условиях жесткого давления со стороны оппонентов с неограниченным ресурсом.</p>
                  </div>
                </div>

                {}
                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="border border-border rounded-sm p-5 flex items-start gap-4 bg-background/50">
                    <div className="bg-white text-primary p-2 rounded-sm shadow-sm shrink-0 border border-border">
                      <Brain className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="text-primary font-medium text-sm mb-1">Глубокая экспертиза</h4>
                      <p className="text-secondary text-xs font-sans">Детальный анализ каждой ситуации</p>
                    </div>
                  </div>
                  <div className="border border-border rounded-sm p-5 flex items-start gap-4 bg-background/50">
                    <div className="bg-white text-primary p-2 rounded-sm shadow-sm shrink-0 border border-border">
                      <ShieldCheck className="w-4 h-4" />
                    </div>
                    <div>
                      <h4 className="text-primary font-medium text-sm mb-1">Полная прозрачность</h4>
                      <p className="text-secondary text-xs font-sans">Честная оценка перспектив дела</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 items-center">
                <Button asChild size="lg" className="w-full sm:w-auto rounded-sm px-8 h-14 text-base bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-300">
                  <Link to="/ContactPage">
                    Записаться на консультацию
                    <ArrowRight className="w-4 h-4 ml-2" />
                  </Link>
                </Button>
                <p className="text-sm text-secondary font-medium font-sans">
                  Офис в центре Калуги
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>;
}